// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AppConfig } from "../../config/config";
import { SnackMessage } from "../../config/constant";
import { PublicAPIService } from "../../utils/publicApiService";
import { GetLeaderboardRequestState, LeaderboardResponse } from "../../utils/types";
import { enqueueSnackbarMessage } from "../commonSlice/common";

const initialState: GetLeaderboardRequestState = {
  state: "idle",
  stateMessage: null,
  errorMessage: null,
  response: {},
  backgroundProcess: false,
  backgroundProcessMessage: null
};

export const getLeaderboard = createAsyncThunk(
  "leaderboard",
  async (_,{dispatch}) => {
    return new Promise<{ response: LeaderboardResponse }>(
      (resolve, reject) => {
        PublicAPIService.getInstance()
          .get(
            AppConfig.serviceUrls.getLeaderboard
          )
          .then((resp) => {
            if (resp.status == 200) {
              resolve({ response: resp.data });
            } else {
              reject("Something went wrong");
            }
          })
          .catch((error: Error) => {
            dispatch(
              enqueueSnackbarMessage({
                message: SnackMessage.error.leaderboardFetch,
                type: "error",
              })
            );
            reject(error);
          });
      }
    );
  }
);

const leaderboard = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLeaderboard.pending, (state, action) => {
        state.stateMessage = "Fetching leaderboard";
        state.state = "loading";
        state.backgroundProcess = true;
        state.backgroundProcessMessage = "Fetching leaderboard";

      })
      .addCase(getLeaderboard.fulfilled, (state, action) => {
        state.state = "success";
        state.response = action.payload.response;
        state.backgroundProcess = false;
      })
      .addCase(getLeaderboard.rejected, (state, action) => {
        state.state = "failed";
        state.stateMessage = "Failed to fetch leaderboard";
        state.backgroundProcess = false;
      });
  },
});

export default leaderboard.reducer;
